/*
 * This module manages the links back to the dashboard from the Activities page.
 */
define('dashboard-nav',['loader', 'jquery', 'angular'], function(loader, $, ng) {
    'use strict';

    var dashNav = ng.module('dashNav', []);

    dashNav.controller('DashboardNavController', ['$scope', '$rootScope', function($scope, $rootScope) {
        // Check to see if we need to update the URL's linking to the dashboard:
        if( window.location.pathname.toLowerCase() === "/activities" && window.location.hash.length > 0 ) {
            // We might have a locked activity to unlock
            var activityId = parseInt(window.location.hash.replace("#!/", "").replace("#/", ""));
            if( ng.isNumber(activityId) && !isNaN(activityId) ) {
                $("#main_nav a[href]").filter(function(){
                    return $(this).attr("href").toLowerCase().indexOf("/dashboard") === 0;
                }).each(function(index, link){
                    var href = $(link).attr("href");
                    var hrefArr = href.split("#");
                    hrefArr[0] = hrefArr[0] + "?unlock=" + activityId;
                    href = hrefArr.join("#");
                    $(link).attr("href", href);
                });
            }
        } else if( window.location.pathname.toLowerCase() === "/dashboard" ) {
            // We are on the dashboard page, to let's fix links to ourself
            // This keep the page from doing a full page reload
            $("#main_nav a[href]").filter(function(){
                return $(this).attr("href").toLowerCase().indexOf("/dashboard") === 0;
            }).each(function(index, link){
                var href = $(link).attr("href").replace(/\/dashboard/i, '');
                if(href.length === 0) {
                    href = '#/';
                }
                $(link).attr("href", href);
            });
        }
    }]);
});
